import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapSharedService } from 'app/services/map-shared.service';
import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';

export interface LayerControlItem {
	isOn: boolean;
	label: string;
	// transparency: number;
	// color: string;
	olLayer: VectorLayer<any> | LayerGroup;
	selectOptions?: SelectOption[];
	opacitySlider?: boolean;
	initOpacity?: number;
	hasToggle?: boolean;
}
export interface SelectOption {
	label: string;
	selected?: boolean;
	value: any; // For bdry layer, it's cateCode; For basemap, it's title
}

@Component({
  selector: 'app-layer-control-item',
  templateUrl: './layer-control-item.component.html',
  styleUrls: ['./layer-control-item.component.css']
})
export class LayerControlItemComponent implements OnInit {

	@Input() layerItem: LayerControlItem;

	@Output() toggleLayer: EventEmitter<LayerControlItem> = new EventEmitter();
	@Output() selectItem: EventEmitter<LayerControlItem> = new EventEmitter();

	selectedItem;

	layerOpacity = 1;

	constructor(
		private mapSharedService: MapSharedService
	) { }

	onToggleLayer() {
		this.toggleLayer.emit(this.layerItem);
	}
	onSelectItem() {
		this.layerItem.selectOptions.forEach(o => {
			o.selected = o === this.selectedItem;
		})
		this.selectItem.emit(this.layerItem);
	}
	onOpacitySliderDragEnd() {
		let olLayer = this.layerItem.olLayer;
		this.mapSharedService.updateLayerOpacity(olLayer, this.layerOpacity);
	}
	ngOnInit() {
		if (this.layerItem && this.layerItem.selectOptions) {
			this.selectedItem = this.layerItem.selectOptions.find(o => o.selected);
			if (this.layerItem.initOpacity || this.layerItem.initOpacity === 0) {
				this.layerOpacity = this.layerItem.initOpacity;
			}
		}
	}

}
